import { Editor } from '@tinymce/tinymce-react';
import NoValue from 'Components/Atoms/NoValue/NoValue';
import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import styles from './HTMLField.module.sass';

interface Props {
    isEdit: boolean,
    value: string,
    onChange: (value: string) => any,
    fieldProperties: any
}

const HTMLField = ({ isEdit, value, onChange, fieldProperties }: Props) => {
    const editorRef: any = useRef(null);
    const [localValue, setLocalValue] = useState(value ?? '');
    const lastSentValue = useRef(value);

    useEffect(() => {
        if (value !== lastSentValue.current) {
            setLocalValue(value ?? '');
            lastSentValue.current = value;
        }
    }, [value]);

    if (!isEdit && fieldProperties?.isInline) {
        const regex = /(<([^>]+)>)/ig;
        const result = value?.replace(regex, '');

        return <>{result}</>;
    }

    return !isEdit
        ? <>{value ? <div className={styles.alignLeft} dangerouslySetInnerHTML={{ __html: value }} /> : <NoValue />}</>
        : <>
            <Editor
                // apiKey='jj93h9sj60y0jobenpdq5gr9pkl5ld3if1xpv62qgzxdfvn2'
                apiKey='k93q9k598e2cletsgindp73xk0bsbumbjzqrryzrcnflhk95'
                onInit={(evt, editor) => editorRef.current = editor}
                value={localValue}
                init={{
                    height: fieldProperties?.height || 600,
                    menubar: false,
                    plugins: [
                        'advlist',
                        'autolink',
                        'lists',
                        'link',
                        'image',
                        'charmap',
                        'print',
                        'preview',
                        'anchor',
                        'searchreplace',
                        'visualblocks',
                        'code',
                        'fullscreen',
                        'insertdatetime',
                        'media',
                        'table',
                        'paste',
                        'code',
                        'help',
                        'wordcount'
                    ],
                    toolbar: 'undo redo | styles | bold italic | bullist numlist | alignleft aligncenter alignright | removeformat code',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                }}
                onEditorChange={(newValue) => {
                    lastSentValue.current = newValue;
                    setLocalValue(newValue);
                    onChange(newValue);
                }}
            />
        </>
}

export default connect(
    () => ({}),
    {}
)(HTMLField);